import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import img1 from "../../assets/image/laptop1.jpg";
import img2 from "../../assets/image/laptop2.jpg";
import img3 from "../../assets/image/laptop3.jpg";
import img4 from "../../assets/image/laptop4.jpg";
import { Link } from "react-router-dom";

function DiscoverBootcamps({ onClick, ...rest }) {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  return (
    <div className="discover-background">
      <div className="discover-container">
        <div className="discover-header">
          <h2>DISCOVER YOUR NEXT STEP</h2>
          <h3>Explore Our Amazing Bootcamps</h3>
        </div>
      </div>

      <Carousel responsive={responsive}>
        <div className="container">
          <div className="card my-card">
            <img src={img1} className="card-img-top" alt="Full Stack Web Development" />
            <div className="card-body">
              <h5 className="card-title">Full Stack Web Development</h5>
              <p className="card-text">
                Master HTML, CSS, JavaScript, React, Node.js, and MongoDB. Build real-world 
                projects from scratch and deploy them.
              </p>
              <div className="align-left-items">
                <a href="#" className="more-info">
                  More Info <span>&#x2192;</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="card my-card">
            <img src={img2} className="card-img-top" alt="Data Structures & Algorithms" />
            <div className="card-body">
              <h5 className="card-title">Data Structures & Algorithms</h5>
              <p className="card-text">
                Cover arrays, linked lists, trees, graphs, DP, and more. Prepare 
                for technical interviews at top tech companies.
              </p>
              <Link to="#" className="more-info">
                More Info <span>&#x2192;</span>
              </Link>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="card my-card">
            <img src={img3} className="card-img-top" alt="UI/UX Design Bootcamp" />
            <div className="card-body">
              <h5 className="card-title">UI/UX Design Bootcamp</h5>
              <p className="card-text">
                Learn design principles, Figma, prototyping, and user research. 
                Build a portfolio with 5 complete case studies.
              </p>
              <Link to="#" className="more-info">
                More Info <span>&#x2192;</span>
              </Link>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="card my-card">
            <img src={img4} className="card-img-top" alt="Cloud & DevOps" />
            <div className="card-body">
              <h5 className="card-title">Cloud & DevOps</h5>
              <p className="card-text">
                Get hands-on with AWS, Docker, Kubernetes, CI/CD pipelines, 
                and infrastructure as code using Terraform.
              </p>
              <Link to="#" className="more-info">
                More Info <span>&#x2192;</span>
              </Link>
            </div>
          </div>
        </div>
      </Carousel>
    </div>
  );
}

export default DiscoverBootcamps;
